<!-- template html -->
<template>
    <div class="modal fade cropper-modal" id="imageCropperContainer" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-575 modal-top-spacing cropper-modal">
            <div class="modal-content">
                <div class="modal-header position-relative">
                    <h1 class="modal-title">Edit your image</h1>
                    <button type="button" class="modal-close" @click="closeCropper" data-bs-dismiss="modal" aria-label="Close">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.2543 1.7168L9.07513 8.89599L16.2543 16.0752" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M1.89594 16.0752L9.07513 8.896L1.89594 1.71681" stroke="#1E2437" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <!-- modal-header -->
                <div ref="cropperBody" class="modal-body cropper-body">
                    <div id="crop-image-container">

                    </div>
                </div>
                <div class="cropper-footer">
                    <div class="row g-2">
                        <div class="col-4">
                            <button type="button" @click="closeCropper" class="outline-btn-dark close-modal" data-bs-dismiss="modal">Delete</button>
                        </div>
                        <div class="col-4">
                            <button @click="rotateImage" class="image-rotate outline-btn-lite">Rotate <span class="d-none d-lg-inline">image</span> </button>
                        </div>
                        <div class="col-4">
                            <button type="button" @click="submitImageCover" class="theme-btn-lite save-modal">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <GenericLoader :isLoading="isLoading" :loadingText="loaderText" />
</template>
<!-- template html -->
<!-- script -->
<script>
    import GenericLoader from '../common/GenericLoader.vue'
    export default {
        name: 'ImageCropper',
        components: {
            GenericLoader
        },
        props: {
            collection: String,
            cropperContainers: String
        },
        data: function () {
            return {
                croppi: null,
                isLoading: false,
                messageImageUrl: null,
                loaderText: "",
                thankyouImageUrl: "",
                currentRotation: 0
            }
        },
        mounted: function () {
            if (this.croppi) {
                this.croppi.croppie('destroy');
            }
            $('#imageCropperContainer').on('shown.bs.modal', this.initializeCroppie);
            $('#imageCropperContainer, .close-modal').on('hidden.bs.modal', this.destroyCroppie);
        },
        beforeDestroy() {
            $('#imageCropperContainer').off('shown.bs.modal', this.initializeCroppie);
            $('#imageCropperContainer, .close-modal').off('hidden.bs.modal', this.destroyCroppie);

        },
        methods: {
            submitImageCover() {
                var that = this
                this.isLoading = true
                this.loaderText = "Generating image preview";
                //ajax call to save image
                if (that.cropperContainers == window.APP_CONSTANTS.GROUP_CARD_COVER_CROPPER_CONTAINER) {
                    that.croppi.croppie('result', {
                        type: 'blob',
                        format: null,
                        size: 'original',
                    }).then(function (resp) {
                        $('.modal').modal('hide');

                        if (window.FormData) {
                            var formdata = new FormData();
                            var fileCover = resp;


                            formdata.append("image", fileCover);


                            fetch('/image/TransformImageGroupCardCover', {
                                method: 'POST',
                                body: formdata
                            }).then((response) => response.text())
                                .then(data => {
                                    $('._image_upload_img_').attr('src', data);
                                    that.isLoading = false;
                                })
                                .catch(error => {
                                    console.error('There was a problem with the fetch operation:', error);
                                    that.isLoading = false;
                                });
                        }
                    });
                }
                else if (that.cropperContainers == window.APP_CONSTANTS.GROUP_CARD_MESSAGE_CROPPER_CONTAINER) {
                    //ajax call to save image
                    that.croppi.croppie('result', {
                        type: 'blob',
                        format: null,
                        size: 'original',
                    }).then(function (resp) {
                        $('.modal').modal('hide');
                        if (window.FormData) {
                            var formdata = new FormData();
                            var fileCover = resp;

                            formdata.append("image", fileCover);

                            fetch('/image/TransformImageGroupCardMessage', {
                                method: 'POST',
                                body: formdata
                            }).then((response) => response.text())
                                .then(data => {
                                    that.isLoading = false
                                    that.$emit('uploadImageUrl', data)
                                })
                                .catch(error => {
                                    console.error('There was a problem with the fetch operation:', error);
                                    that.isLoading = false;
                                });
                        }
                    });
                }
                else if (that.cropperContainers == window.APP_CONSTANTS.THANK_YOU_NOTE_CROPPER_CONTAINER) {
                    that.croppi.croppie('result', {
                        type: 'blob',
                        format: null,
                        size: 'original',
                    }).then(function (resp) {
                        $('#imageCropperContainer').modal('hide');
                        if (window.FormData) {
                            var formdata = new FormData();
                            var fileCover = resp;
                            formdata.append("image", fileCover, fileCover.name);

                            fetch('/Image/TransformImageThankYouNote', {
                                method: 'POST',
                                body: formdata
                            }).then((response) => response.text())
                                .then(data => {
                                    that.isLoading = false;
                                    that.thankyouImageUrl = data;
                                    if (data) {
                                        that.$emit('thankyouImageUrl', { data, fileCover });
                                    }
                                })
                                .catch(error => {
                                    console.error('There was a problem with the fetch operation:', error);
                                    that.isLoading = false;
                                });
                        }
                    });
                }
            },
            closeCropper() {
                this.croppi.croppie('destroy');
                $('.modal').modal('hide');
            },
            rotateImage() {
                 this.currentRotation -= 90;

                if ( this.currentRotation <= -360) {
                     this.currentRotation = 0;
                }

                 this.croppi.croppie('rotate', -90);

                // Determine minimum zoom based on aspect ratio
                let minZoom = ( this.croppi.croppie('get').originalWidth >  this.croppi.croppie('get').originalHeight) ? 0.2 : 0.1;

                if ( this.currentRotation === 0) {
                     this.croppi.croppie('setZoom', minZoom); // Use calculated minimum zoom
                } else {
                     this.croppi.croppie('setZoom', 0.5);
                }
            },
            initializeCroppie() {
                var that = this
                let fullPageGroupCardImage = document.querySelector('._fullPageImage_,.PhotoUpload_Portrait_');
                let circleGroupCardImage = document.querySelector('._photoOrangeCircle_,.PhotoUpload_Circle_');
                let landscapeGroupCardImage = document.querySelector('._photoFullPageLandscape_,._photoFullPageLandscapeSympathy_,.PhotoUpload_Landscape_');
                let landscapeSmallGroupCardImage = document.querySelector('._photoLogoNavyBorder_,._grassThanksManager_,._grassThanksCoach_');
                let circleGroupCardImageInvitation = document.querySelector('.photoOrangeCircle');
                let landscapeGroupCardImageInvitation = document.querySelector('.photoFullPageLandscape');
                let landscapeSmallGroupCardImageInvitation = document.querySelector('.photoLogoNavyBorder');

                if (this.cropperContainers == window.APP_CONSTANTS.GROUP_CARD_MESSAGE_CROPPER_CONTAINER || this.cropperContainers == window.APP_CONSTANTS.THANK_YOU_NOTE_CROPPER_CONTAINER) {

                    let width = document.getElementById('crop-image-container').offsetWidth - window.APP_CONSTANTS.IMAGE_CONTAINER_WIDTH;
                    $('#crop-image-container').height(window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER_DEFAULT);

                    // Define default viewport dimensions
                    var defaultViewport = {
                        width: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER_DEFAULT,
                        height: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER_DEFAULT,
                        type: 'rectangle'
                    };

                    // Check if the screen width is less
                    if ($(window).width() < window.APP_CONSTANTS.DEFAULT_LESS_WIDTH) {
                        defaultViewport = {
                            width: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER,
                            height: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER,
                            type: 'rectangle'
                        };
                        $('#crop-image-container').height(window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER);
                    }

                    that.croppi = $('#crop-image-container').croppie({
                        viewport: defaultViewport,
                        enableOrientation: true,
                    });


                    $('.cropper-body').height(document.getElementById('crop-image-container').offsetHeight + window.APP_CONSTANTS.CROPPER_BODY_HEIGHT + 'px');
                    that.croppi.croppie('bind', {
                        url: window.src,
                    }).then(function () {
                        that.croppi.croppie('setZoom', window.APP_CONSTANTS.CROPPER_ZOOM_SCALE);
                    });
                }
                else {

                    // fullPageGroupCardImage
                    if (fullPageGroupCardImage) {
                        let width = document.getElementById('crop-image-container').offsetWidth - window.APP_CONSTANTS.IMAGE_CONTAINER_WIDTH;
                        $('#crop-image-container').height(window.APP_CONSTANTS.FULL_PAGE_IMAGE_CROPPER_CONTAINER_HEIGHT_DEFAULT);

                        // Define default viewport dimensions
                        var defaultViewport = {
                            width: window.APP_CONSTANTS.FULL_PAGE_IMAGE_CROPPER_CONTAINER_WIDTH_DEFAULT,
                            height: window.APP_CONSTANTS.FULL_PAGE_IMAGE_CROPPER_CONTAINER_HEIGHT_DEFAULT
                        };

                        // Check if the screen width is less
                        if ($(window).width() < window.APP_CONSTANTS.DEFAULT_LESS_WIDTH) {
                            defaultViewport = {
                                width: window.APP_CONSTANTS.FULL_PAGE_IMAGE_CROPPER_CONTAINER_WIDTH,
                                height: window.APP_CONSTANTS.FULL_PAGE_IMAGE_CROPPER_CONTAINER_HEIGHT
                            };
                            $('#crop-image-container').height(window.APP_CONSTANTS.FULL_PAGE_IMAGE_CROPPER_CONTAINER_HEIGHT);
                        }

                        this.croppi = $('#crop-image-container').croppie({
                            viewport: defaultViewport,
                            enableOrientation: true,
                        });


                        $('.cropper-body').height(document.getElementById('crop-image-container').offsetHeight + window.APP_CONSTANTS.CROPPER_BODY_HEIGHT + 'px');
                        this.croppi.croppie('bind', {
                            url: window.src,
                        }).then(function () {
                            that.croppi.croppie('setZoom', window.APP_CONSTANTS.CROPPER_ZOOM_SCALE);
                        });
                    }
                    // circleGroupCardImage
                    else if (circleGroupCardImage || circleGroupCardImageInvitation) {
                        let width = document.getElementById('crop-image-container').offsetWidth - window.APP_CONSTANTS.IMAGE_CONTAINER_WIDTH;
                        $('#crop-image-container').height(window.APP_CONSTANTS.CIRCLE_IMAGE_CROPPER_CONTAINER_DEFAULT);

                        // Define default viewport dimensions
                        var defaultViewport = {
                            width: window.APP_CONSTANTS.CIRCLE_IMAGE_CROPPER_CONTAINER_DEFAULT,
                            height: window.APP_CONSTANTS.CIRCLE_IMAGE_CROPPER_CONTAINER_DEFAULT,
                            type: 'circle'
                        };

                        // Check if the screen width is less
                        if ($(window).width() < window.APP_CONSTANTS.DEFAULT_LESS_WIDTH) {
                            defaultViewport = {
                                width: window.APP_CONSTANTS.CIRCLE_IMAGE_CROPPER_CONTAINER,
                                height: window.APP_CONSTANTS.CIRCLE_IMAGE_CROPPER_CONTAINER,
                                type: 'circle'
                            };
                            $('#crop-image-container').height(window.APP_CONSTANTS.CIRCLE_IMAGE_CROPPER_CONTAINER);
                        }

                        that.croppi = $('#crop-image-container').croppie({
                            viewport: defaultViewport,
                            enableOrientation: true,
                        });


                        $('.cropper-body').height(document.getElementById('crop-image-container').offsetHeight + window.APP_CONSTANTS.CROPPER_BODY_HEIGHT + 'px');
                        that.croppi.croppie('bind', {
                            url: window.src,
                        }).then(function () {
                            that.croppi.croppie('setZoom', window.APP_CONSTANTS.CROPPER_ZOOM_SCALE);
                        });
                    }
                    // landscapeGroupCardImage
                    else if (landscapeGroupCardImage || landscapeGroupCardImageInvitation) {
                        let width = document.getElementById('crop-image-container').offsetWidth - window.APP_CONSTANTS.IMAGE_CONTAINER_WIDTH;
                        $('#crop-image-container').height(window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT_DEFAULT);

                        // Define default viewport dimensions
                        var defaultViewport = {
                            width: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_WIDTH_DEFAULT,
                            height: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT_DEFAULT,
                            type: 'rectangle'
                        };

                        // Check if the screen width is less
                        if ($(window).width() < window.APP_CONSTANTS.DEFAULT_LESS_WIDTH) {
                            defaultViewport = {
                                width: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_WIDTH,
                                height: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT,
                                type: 'rectangle'
                            };
                            $('#crop-image-container').height(window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT);
                        }

                        that.croppi = $('#crop-image-container').croppie({
                            viewport: defaultViewport,
                            enableOrientation: true,
                        });

                        $('.cropper-body').height(document.getElementById('crop-image-container').offsetHeight + window.APP_CONSTANTS.CROPPER_BODY_HEIGHT + 'px');
                        that.croppi.croppie('bind', {
                            url: window.src,
                        }).then(function () {
                            that.croppi.croppie('setZoom', window.APP_CONSTANTS.CROPPER_ZOOM_SCALE);
                        });
                    }
                    // landscapeSmallGroupCardImage
                    else if (landscapeSmallGroupCardImage || landscapeSmallGroupCardImageInvitation) {
                        let width = document.getElementById('crop-image-container').offsetWidth - window.APP_CONSTANTS.IMAGE_CONTAINER_WIDTH;
                        $('#crop-image-container').height(window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT_DEFAULT);

                        // Define default viewport dimensions
                        var defaultViewport = {
                            width: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_WIDTH_DEFAULT,
                            height: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT_DEFAULT,
                            type: 'rectangle'
                        };

                        // Check if the screen width is less
                        if ($(window).width() < window.APP_CONSTANTS.DEFAULT_LESS_WIDTH) {
                            defaultViewport = {
                                width: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_WIDTH,
                                height: window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT,
                                type: 'rectangle'
                            };
                            $('#crop-image-container').height(window.APP_CONSTANTS.RECTANGLE_IMAGE_CROPPER_CONTAINER_HEIGHT);
                        }

                        that.croppi = $('#crop-image-container').croppie({
                            viewport: defaultViewport,
                            enableOrientation: true,
                        });

                        $('.cropper-body').height(document.getElementById('crop-image-container').offsetHeight + window.APP_CONSTANTS.CROPPER_BODY_HEIGHT + 'px');
                        that.croppi.croppie('bind', {
                            url: window.src,
                        }).then(function () {
                            that.croppi.croppie('setZoom', window.APP_CONSTANTS.CROPPER_ZOOM_SCALE);
                        });
                    }
                    // squareGroupCardImage
                    else {
                        let width = document.getElementById('crop-image-container').offsetWidth - window.APP_CONSTANTS.IMAGE_CONTAINER_WIDTH;
                        $('#crop-image-container').height(window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER_DEFAULT);

                        // Define default viewport dimensions
                        var defaultViewport = {
                            width: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER_DEFAULT,
                            height: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER_DEFAULT,
                            type: 'rectangle'
                        };

                        // Check if the screen width is less
                        if ($(window).width() < window.APP_CONSTANTS.DEFAULT_LESS_WIDTH) {
                            defaultViewport = {
                                width: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER,
                                height: window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER,
                                type: 'rectangle'
                            };
                            $('#crop-image-container').height(window.APP_CONSTANTS.SQUARE_IMAGE_CROPPER_CONTAINER);
                        }

                        that.croppi = $('#crop-image-container').croppie({
                            viewport: defaultViewport,
                            enableOrientation: true,
                        });


                        $('.cropper-body').height(document.getElementById('crop-image-container').offsetHeight + window.APP_CONSTANTS.CROPPER_BODY_HEIGHT + 'px');
                        that.croppi.croppie('bind', {
                            url: window.src,
                        }).then(function () {
                            that.croppi.croppie('setZoom', window.APP_CONSTANTS.CROPPER_ZOOM_SCALE);
                        });
                    }

                }
            },
            destroyCroppie() {
                // Destroy Croppie when modal is hidden
                if (this.croppi) {
                    this.croppi.croppie('destroy');
                }
            }

        }
    }
</script>
<!-- script -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
